/**
 * Decision 25: house ads only in downtime, never on the report screen, during
 * an unreported live match, in onboarding, or on any TO screen. Every screen
 * asks this resolver which slot (if any) applies, so placement cannot drift.
 */
export type AdSlot = 'a' | 'b' | 'c' | 'd';

export interface AdSlotInput {
  adsEnabled: boolean;
  /** Which screen is asking */
  screen: 'player-home' | 'report' | 'name-step' | 'deck' | 'host' | 'live' | 'invite' | 'profile';
  /** PLAYER screens only */
  viewer?: {
    dropped: boolean;
    /** Tournament status */
    status: 'LOBBY' | 'PAIRED' | 'LIVE' | 'COMPLETE';
    /** The viewer has a live, unreported match right now */
    liveUnreported: boolean;
    /** The viewer has reported (or has a bye) in the live round */
    liveDone: boolean;
  };
}

export const resolveAdSlot = ({ adsEnabled, screen, viewer }: AdSlotInput): AdSlot | null => {
  if (!adsEnabled) return null;
  switch (screen) {
    case 'live':
      return 'd';
    case 'player-home': {
      if (!viewer || viewer.dropped) return null;
      if (viewer.status === 'COMPLETE') return 'c';
      if (viewer.liveUnreported) return null;
      if (viewer.status === 'LIVE' && viewer.liveDone) return 'b';
      if (viewer.status === 'LOBBY') return 'a';
      return null;
    }
    // report, name-step, deck (onboarding), host, invite, profile: never
    default:
      return null;
  }
};
